import CheckIcon from 'icons/check.svg';

import classes from 'styles/components/Preload.module.scss';

// The purpose of this component is to hack around an issue where when
// the first occurrence of a svg is not displayed, none are visible

const Preload = () => (
  <div className={classes.root}>
    <CheckIcon />
  </div>
);

export default Preload;
